module.exports = __webpack_public_path__ + "static/media/70B5B92D-90A4-4D70-9B63-9235BFF78F45-min.04e2b40c.jpg";